import { Form } from '@formio/react'
import { toastConfig } from '../../constants/other.config'
import toast from 'react-hot-toast'

import { CModal, CModalHeader, CModalTitle, CModalFooter, CModalBody, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CFormText, CContainer } from '@coreui/react'
import { CCol, CRow, CCard, CCardBody, CFormLabel, CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem, CButtonGroup, CCardTitle, CCardText, CCardImage, CButton, CFormSelect, CCardHeader } from '@coreui/react'

import SavePatientDiagnosisData from '../../services/general/savePatientDiagnosisData.api.js'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import GetQuestionBank from '../../services/general/saveQuestionBank.api'
import GetPatientDiagnosisDetails from '../../services/general/getPatientDiagnosisDetails.api'

import React, { useRef, useState, useEffect } from 'react'
import SavePatients from '../../services/general/savePatientinformation.api'
import ModifyPatientMap from '../../services/general/modifyPatientMap.api.js'
import PatientNoteDataCRUD from '../../services/general/patientNoteData.api'
import FormQuestionRender from '../../components/shared/FormQuestionRender'
import AppSelect from '../../components/shared/AppSelect'

export const Questions2 = ({ patientData, saveQuestions }) => {
  const [render, setRender] = useState(false)
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
  const [patientDiagnosisList, setPatientDiagnosisList] = useState([])
  const [diagnosisData, setDiagnosisData] = useState([])
  const [newDiagnosis, setNewDiagnosis] = useState([])
  const [visible, setVisible] = useState(false)
  const [formAnswers, setFormAnswers] = useState([])
  const [validComponents, setValidComponents] = useState([])
  const [validDiagnosis, setValidDiagnosis] = useState([])

  const getData = async () => {
    let a = await GetDiagnosisData()
    let data = JSON.parse(a.d)
    let options = data.Data.map((obj) => ({
      value: obj.id,
      label: obj.Name.trim(),
    }))
    ?.sort((a, b) => a.label.localeCompare(b.label))
    setDiagnosisData(options)
  }

  const GetPatientDiagnosis = async () => {
    try {
      const response = await ModifyPatientMap('GETALL', patientData.PatientID)
      const formattedDiagnosis = JSON.parse(response.d)
      const formattedDiagnosisAll = formattedDiagnosis?.Data.filter((obj) => obj.PatientID === patientData.PatientID) || []
      const patientDetails = Array.isArray(formattedDiagnosisAll) ? formattedDiagnosisAll[0] : {}
      const patientDetailsDiagnosis = patientDetails.Diagnosis ? (patientDetails.Diagnosis.includes(',') ? patientDetails.Diagnosis.split(',') : [patientDetails.Diagnosis]) : []
      console.log("patient Diagnosis data",patientDetails )
      setPatientDiagnosisList(patientDetailsDiagnosis)
      setRender((p) => !p)
    } catch (error) {
      console.error('Error fetching patient diagnosis:', error)
    }
  }

  useEffect(() => {
    getData()
    GetPatientDiagnosis()
  }, [])

  useEffect(() => {
    fetchData()
  }, [render])

  const fetchData = async () => {
    const allComponents = []
    const validDiagnosisList = []

    for (let diagnosis of patientDiagnosisList) {
      try {
        formData.current.push([])
        const response = await GetQuestionBank('', diagnosis, '')
        const component = JSON.parse(response.d)
        allComponents.push(component)
        validDiagnosisList.push(diagnosis)

        console.log("question bank data",component )
      } catch (e) {
        console.error('Error fetching question bank:', e)
      }
    }

    try {
      const tempAnswers = await GetPatientDiagnosisDetails(patientData.PatientID)
      const data = JSON.parse(tempAnswers.d)
      const formAnswersStr = data.Data.length > 0 ? data.Data[0].DiagnosisDetails : '[]'
      const tempData = JSON.parse(formAnswersStr)
      setFormAnswers(tempData)
    } catch (e) {
      console.error('Error fetching patient diagnosis details:', e)
    }

    setValidComponents(allComponents)
    setValidDiagnosis(validDiagnosisList)
  }

  const formData = useRef([])

  const addDiagnosis = () => {
    setVisible(true)
  }
  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`
  }

  const parseJsonSafely = (value, fallback = {}) => {
    if (!value) return fallback
    if (typeof value === 'object') return value

    try {
      return JSON.parse(value)
    } catch (error) {
      console.error('Error parsing JSON:', error)
      return fallback
    }
  }

  const normalizeDiagnosisLabel = (value) => String(value?.label ?? value?.Name ?? value ?? '').trim()

  const getSelectedDiagnosisOption = () =>
    diagnosisData.find((item) => normalizeDiagnosisLabel(item.label) === normalizeDiagnosisLabel(selectedDiagnosis))

  const getTreatmentNotesData = async () => {
    const treatmentNotesData = await PatientNoteDataCRUD('GET', patientData.PatientID)
    const parsedResponse = parseJsonSafely(treatmentNotesData?.d, {})
    const notes = Array.isArray(parsedResponse?.Data) ? parsedResponse.Data : []

    return notes.map((item) => ({
      ...item,
      data: parseJsonSafely(item?.data, {}),
    })).sort((noteA, noteB) => {
      const noteATime = new Date(noteA?.CreatedAt || noteA?.newDate || '').getTime()
      const noteBTime = new Date(noteB?.CreatedAt || noteB?.newDate || '').getTime()

      if (!Number.isNaN(noteATime) && !Number.isNaN(noteBTime) && noteATime !== noteBTime) {
        return noteATime - noteBTime
      }

      return Number(noteA?.id || noteA?.Id || 0) - Number(noteB?.id || noteB?.Id || 0)
    })
  }

  const getUniqueDiagnosisIds = (currentIds = [], diagnosisId) => {
    const seenIds = new Set()
    const ids = Array.isArray(currentIds) ? currentIds : []

    return [...ids, diagnosisId].filter((id) => {
      if (id === undefined || id === null || id === '') return false

      const key = String(id)
      if (seenIds.has(key)) return false

      seenIds.add(key)
      return true
    })
  }

  const noteHasDiagnosisId = (note, diagnosisId) => {
    const diagnosisIds = note?.data?.metadata?.diagnosisIds || []
    return Array.isArray(diagnosisIds) && diagnosisIds.some((id) => String(id) === String(diagnosisId))
  }

  const getNoteFlag = (flag) => !(flag === false || flag === 'false')

  const syncDiagnosisIdToLatestNote = async (diagnosisOption, shouldVerify = true) => {
    if (!diagnosisOption?.value) return false

    const treatmentNotesData = await getTreatmentNotesData()
    const takeLatestNote = treatmentNotesData[treatmentNotesData.length - 1]

    console.log(diagnosisOption, 'findIdDiagnosis')
    console.log('takeLatestNote before', takeLatestNote)

    const noteId = takeLatestNote?.id || takeLatestNote?.Id

    if (!noteId) {
      console.error('No latest treatment note found for diagnosis metadata update')
      return false
    }

    const latestNoteData = takeLatestNote.data || {}
    const uniqueDiagnosisIds = getUniqueDiagnosisIds(latestNoteData?.metadata?.diagnosisIds, diagnosisOption.value)
    const currentInformation = latestNoteData?.information || {}
    const existingInformation = currentInformation?.[diagnosisOption.label]
    const existingData = Array.isArray(existingInformation) ? existingInformation : existingInformation ? [existingInformation] : []
    const updatedInformation = existingData.includes('Call Center') ? existingData : [...existingData, 'Call Center']
    const updatedNoteData = {
      ...latestNoteData,
      metadata: {
        ...(latestNoteData?.metadata || {}),
        diagnosisIds: uniqueDiagnosisIds,
      },
      information: {
        ...currentInformation,
        [diagnosisOption.label]: updatedInformation,
      },
    }

    console.log(updatedNoteData, 'takeLatestNote after')

    await PatientNoteDataCRUD('UPDATE', patientData?.PatientID?.toString(), noteId?.toString(), JSON.stringify(updatedNoteData), getFormattedDate().toString(), takeLatestNote?.status || 'Draft', getNoteFlag(takeLatestNote?.flag))

    if (shouldVerify) {
      const refreshedNotes = await getTreatmentNotesData()
      const refreshedLatestNote = refreshedNotes[refreshedNotes.length - 1]

      if (!noteHasDiagnosisId(refreshedLatestNote, diagnosisOption.value)) {
        console.warn('Diagnosis id was not found in latest note metadata after save. Retrying metadata update.')
        await syncDiagnosisIdToLatestNote(diagnosisOption, false)

        const retryNotes = await getTreatmentNotesData()
        const retryLatestNote = retryNotes[retryNotes.length - 1]

        return noteHasDiagnosisId(retryLatestNote, diagnosisOption.value)
      }
    }

    return true
  }

  const handleModalSave = async () => {
    try {
      const findIdDiagnosis = getSelectedDiagnosisOption()
      const selectedDiagnosisLabel = normalizeDiagnosisLabel(findIdDiagnosis?.label)

      if (!findIdDiagnosis) {
        toast.error('Please select diagnosis', toastConfig)
        return
      }

      const diagnosisUniqueSet = new Set(patientDiagnosisList.map(normalizeDiagnosisLabel).filter(Boolean))
      const metadataSynced = await syncDiagnosisIdToLatestNote(findIdDiagnosis)

      if (!metadataSynced) {
        toast.error('Unable to update diagnosis metadata. Please try again.', toastConfig)
        return
      }

      if (diagnosisUniqueSet.has(selectedDiagnosisLabel)) {
        toast.error('Diagnosis Already Exists', toastConfig)
        return
      }

      diagnosisUniqueSet.add(selectedDiagnosisLabel)

      const allUniqueDiagnosis = Array.from(diagnosisUniqueSet).filter(Boolean)

      await ModifyPatientMap('UPDATE', patientData.PatientID, allUniqueDiagnosis.join(','))

      const metadataSyncedAfterPatientMapUpdate = await syncDiagnosisIdToLatestNote(findIdDiagnosis)

      if (!metadataSyncedAfterPatientMapUpdate) {
        toast.error('Diagnosis was added, but metadata sync failed. Please try again.', toastConfig)
        return
      }

      setNewDiagnosis((p) => [...p, selectedDiagnosisLabel])
      setPatientDiagnosisList(allUniqueDiagnosis)
      setVisible(false)
      setRender((p) => !p)
    } catch (error) {
      console.error('Error saving diagnosis:', error)
      toast.error('Unable to add diagnosis. Please try again.', toastConfig)
    }
  }

  const diagnosisChanged = (e) => {
    setSelectedDiagnosis(e.label)
  }

  const convertUpper = (str) => {
    const arr = str.split(' ')
    for (let i = 1; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1)
    }
    return arr.join('')
  }

  const handleFormSubmit = async () => {
    let idNumber = patientData.PatientID
    // let resp = await SavePatientDiagnosisData(idNumber, patientDiagnosisList.join(','), JSON.stringify(formData.current), 'Completed')
     saveQuestions(patientDiagnosisList.join(','))

     console.log("patientDiagnosisList.join(',')",patientDiagnosisList)
    // history.push("/dashboard/callcenter")
  }

  const handleDeleteDiagnosis = async (diagnosisToDelete, indexComponent) => {
    try {
      if (!newDiagnosis.includes(diagnosisToDelete)) {
        toast.error('Cannot delete previously added diagnosis', toastConfig)
        return
      }

      const index = patientDiagnosisList.findIndex((d) => d === diagnosisToDelete)

      if (index === -1) {
        toast.error('Diagnosis not found in the list', toastConfig)
        return
      }

      setPatientDiagnosisList(patientDiagnosisList.filter((d) => d !== diagnosisToDelete))

      setNewDiagnosis(newDiagnosis.filter((d) => d !== diagnosisToDelete))

      const updatedValidComponents = validComponents.filter((_, i) => i !== indexComponent)

      setValidComponents(updatedValidComponents)

      const updatedDiagnosisList = patientDiagnosisList.filter((d) => d !== diagnosisToDelete)

      await ModifyPatientMap('UPDATE', patientData.PatientID, updatedDiagnosisList.join(','))

      GetPatientDiagnosis()

      // await fetchQuestionWithFormAnswer();
    } catch (e) {
      console.error('Error deleting diagnosis:', e)
    }
  }

  const { PatientID, FirstName, MiddleName, LastName, Gender, EmergencyName, EmergencyPhone, Room, FacilityName, PhoneNumber } = patientData
  const PatientName = FirstName + ' ' + LastName

  return (
    <>
      <CCard className="patient-theme-card mb-3">
        <div className="">
          <CCardBody className="patient-theme-card__body">
            <CRow className="mb-3">
              <CFormLabel className="col-sm-1 col-form-label ui-text-primary">Patient Name:</CFormLabel>
              <CCol sm={10}>
                <div className="ui-static-field">{PatientName}</div>
              </CCol>
              <CFormLabel className="col-sm-2 col-form-label ui-text-primary">Power of Attorney Name:</CFormLabel>
              <CCol sm={10}>
                <div className="ui-static-field">{EmergencyName}</div>
              </CCol>
              <CFormLabel className="col-sm-2 col-form-label ui-text-primary">Power of Attorney Contact Number:</CFormLabel>
              <CCol sm={10}>
                <div className="ui-static-field">{EmergencyPhone}</div>
              </CCol>
              <CFormLabel className="col-sm-2 col-form-label ui-text-primary">All Diagnosis:</CFormLabel>
              <CCol sm={10}>
                <div className="ui-static-field">{patientDiagnosisList ? patientDiagnosisList.join(', ') : ''}</div>
              </CCol>
            </CRow>
            <CButton className="ui-action-btn ui-action-btn--primary mb-2" onClick={addDiagnosis}>
              + Add Diagnosis
            </CButton>
            <CButton className="ui-action-btn ui-action-btn--primary mb-2 ms-2" onClick={handleFormSubmit}>
              Submit
            </CButton>
             
          </CCardBody>
        </div>
      </CCard>

      <CAccordion>
        {/* {validComponents.map((obj, i) => (
          <CContainer key={i} className="d-flex mw-100 align-items-center gap-4">
            <CAccordionItem className="w-100" itemKey={i}>
              <CAccordionHeader>{validDiagnosis[i]}</CAccordionHeader>
              <CAccordionBody>
                <Form
                  key={i}
                  form={obj}
                  submission={formAnswers[i]}
                  onChange={(e) => {
                    formData.current[i] = { data: e.data }
                  }}
                />
              </CAccordionBody>
            </CAccordionItem>
            {newDiagnosis.includes(validDiagnosis[i]) && (
              <CButton className="text-white" style={{ height: 'min-content' }} onClick={() => handleDeleteDiagnosis(validDiagnosis[i], i)} color="danger">
                Delete
              </CButton>
            )}
          </CContainer>
        ))} */}
        <FormQuestionRender  patientID = {patientData?.PatientID}  patientData = {patientData}  noteID={0}  patientDiagnosis={patientDiagnosisList} callingName="callcenter"/>
      </CAccordion>

      <CModal className="patient-theme-modal" visible={visible} onClose={() => setVisible(false)} backdrop="static" keyboard={false} portal={false}>
        <CModalHeader onClose={() => setVisible(false)}>
          <CModalTitle>New Diagnosis</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="mb-3">
            <CFormLabel className="ui-form-label">Select Diagnosis</CFormLabel>
            <AppSelect
              placeholder="Select"
              onChange={(e) => {
                diagnosisChanged(e)
              }}
              options={diagnosisData}
              className="basic-multi-select"
            />
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton className="ui-action-btn ui-action-btn--primary" onClick={handleModalSave}>
            Add
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}
